/**
 * Mock buyer responses per maestro personality.
 * Used in text mode when voice (ElevenLabs) is disabled.
 * Each set reflects the maestro's negotiation style and tone.
 */

const cerrador = [
  'Ya vi la propuesta. Necesito una razon concreta para firmar esto hoy.',
  'Vamos al grano, ¿que necesitas de mi para cerrar esto?',
  'Tengo otra oferta sobre la mesa. ¿Por que deberia elegirte a ti?',
  '¿Para cuando podriamos tener esto firmado si nos ponemos de acuerdo ahora?',
  'No me des rodeos. ¿Cual es tu mejor precio final?',
  'Si me garantizas esos plazos, podemos avanzar. ¿Lo pones por escrito?',
  'Me gusta la propuesta, pero necesito un compromiso concreto, no promesas.',
  'Mira, no tengo todo el dia. Dame tres razones para cerrar contigo.',
  '¿Que pasa si firmo hoy? ¿Hay alguna ventaja adicional?',
  'Bien, me has convencido a medias. ¿Que mas tienes?',
  'El plazo de entrega es critico. ¿Puedes garantizarlo contractualmente?',
  'Otro proveedor me ofrece lo mismo por menos. Convenceme.',
];

const estratega = [
  '¿Que ROI puedo esperar en los primeros seis meses?',
  'Interesante, pero necesito ver los datos que respaldan eso.',
  '¿Tienen algun caso de estudio en empresas de nuestro sector?',
  'Antes de avanzar, necesito entender como se alinea esto con nuestros objetivos estrategicos.',
  '¿Cual seria el proceso de implementacion paso a paso?',
  'Tengo que presentar esto al comite. ¿Puedes prepararme un business case?',
  '¿Que KPIs concretos podemos medir para evaluar el exito?',
  'Comparado con la solucion que usamos actualmente, ¿donde esta la mejora cuantificable?',
  '¿Cuantos stakeholders necesitan estar involucrados en la implementacion?',
  'No tomo decisiones por impulso. Necesito analizar esto internamente.',
  '¿Que riesgos identifican y como los mitigan?',
  '¿Podemos hacer un piloto antes de comprometernos a escala completa?',
];

const provocador = [
  'Eso me lo han dicho diez proveedores antes. ¿Que tienes de diferente?',
  'Perdona que te corte, pero eso no me convence para nada.',
  'Es carisimo. ¿Me estas tomando el pelo con ese precio?',
  'A ver, cambiemos de tema. ¿Por que deberia confiar en tu empresa?',
  'No lo necesitamos. Convenceme de lo contrario si puedes.',
  '¿Y si me va mal? ¿Que garantias me das? ¿Cero riesgo?',
  'Mira, estoy a punto de colgar. Dame algo realmente bueno.',
  '¿Y quien lo dice? ¿Tienes pruebas o es solo palabreria?',
  'Buff, me aburro. ¿No tienes nada mas interesante que ofrecer?',
  'Hmm, vale, eso ultimo no estuvo mal. Sigue por ahi.',
  'Mi ultimo proveedor me prometio lo mismo y fue un desastre. ¿Por que contigo seria diferente?',
  'Me caes bien, pero tu producto no me convence. Vende mejor.',
];

export const MAESTRO_MOCK_RESPONSES: Record<string, string[]> = {
  cerrador,
  estratega,
  provocador,
};

/** Fallback for unknown maestro IDs */
export const DEFAULT_MOCK_RESPONSES = cerrador;
